export default {
  namespace: 'menu',
  state: {
    collapsed: false,
  },
  reducers: {
    switchMenu(state, { payload }) {
      return payload;
    },
  },
};
